import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from '@eo/shared';

const PROVIDERS = [
  { param: 'google', title: 'Google Calendar' },
  { param: 'slack', title: 'Slack' },
] as const;

// The provider redirects the browser back with the outcome in the query
// string. Nothing else reads it, so without this a failed connect is
// indistinguishable from never having pressed the button.
export function useOAuthReturn(): void {
  const [searchParams, setSearchParams] = useSearchParams();
  const announced = useRef(false);

  useEffect(() => {
    if (announced.current) return;
    const hit = PROVIDERS.find((p) => searchParams.get(p.param));
    if (!hit) return;
    announced.current = true;

    const outcome = searchParams.get(hit.param);
    if (outcome === 'connected') toast.success(`${hit.title} connected.`);
    else {
      const reason = searchParams.get('reason');
      toast.error(
        reason
          ? `Connecting ${hit.title} failed: ${reason}`
          : `Connecting ${hit.title} failed. Try again.`,
      );
    }

    // Cleared so a reload doesn't re-announce a stale outcome.
    setSearchParams(
      (params) => {
        params.delete(hit.param);
        params.delete('reason');
        return params;
      },
      { replace: true },
    );
  }, [searchParams, setSearchParams]);
}
